/**
 * Created by cedricgodefroy on 18/07/2017.
 */
/**
 * Created by cedricgodefroy on 18/07/2017.
 */
angular.module('FlexyBeautyApp.services').factory('OptInOutView', ["$timeout", "$filter", "OptInOut", "OptInOutData", "OptInOutSrv", "CustomerData",
    function ($timeout, $filter, OptInOut, OptInOutData, OptInOutSrv, CustomerData) {
        var OptInOutView = function (optInOutModel, optInOutIndex) {
            this.optInOutIndex = optInOutIndex;
            this.id = null;
            this.isSmsCampaignAllowed = false;
            this.isEmailCampaignAllowed = false;
            this.isNotificationCampaignAllowed = false;
            this.isExternalOptInOut = null;
            this.origin = null;
            this.optInOutDateString = null;
            this.optInOutDatePickerOpened = false;
            this.customerId = null;
            this.timeModified = null;
            this.optInOutModel = optInOutModel;

            if (this.optInOutModel) {
                this.loadDataFrom(this.optInOutModel);
            }
        };

        OptInOutView.prototype.loadDataFrom = function (optInOutModel) {
            this.id = optInOutModel.id;
            this.isSmsCampaignAllowed = optInOutModel.isSmsCampaignAllowed ? optInOutModel.isSmsCampaignAllowed : false;
            this.isEmailCampaignAllowed = optInOutModel.isEmailCampaignAllowed ? optInOutModel.isEmailCampaignAllowed : false;
            this.isNotificationCampaignAllowed = optInOutModel.isNotificationCampaignAllowed ? optInOutModel.isNotificationCampaignAllowed : false;
            this.isExternalOptInOut = optInOutModel.isExternalOptInOut ? optInOutModel.isExternalOptInOut : false;
            this.optInOutDate = optInOutModel.optInOutDate;
            this.origin = optInOutModel.origin;
            this.customerId = optInOutModel.customerId;
            this.timeModified = optInOutModel.timeModified;
            this.updateDateString();
            this.optInOutIndex = OptInOutData.getIndexOf(optInOutModel);

        };

        OptInOutView.prototype.isChanged = function () {
            var isChanged = false;
            if (this.optInOutModel.isSmsCampaignAllowed != this.isSmsCampaignAllowed &&
                this.optInOutModel.isEmailCampaignAllowed != this.isEmailCampaignAllowed &&
                this.optInOutModel.isNotificationCampaignAllowed != this.isNotificationCampaignAllowed &&
                this.optInOutModel.isExternalOptInOut != this.isExternalOptInOut
            ) {
                isChanged = true;
            }
            return isChanged;
        };

        OptInOutView.prototype.copyDataTo = function (optInOut) {
            optInOut.isSmsCampaignAllowed = this.isSmsCampaignAllowed;
            optInOut.isEmailCampaignAllowed = this.isEmailCampaignAllowed;
            optInOut.isNotificationCampaignAllowed = this.isNotificationCampaignAllowed;
            optInOut.isExternalOptInOut = this.isExternalOptInOut;
            optInOut.timeModified = this.timeModified;
            optInOut.origin = this.origin;
            optInOut.customerId = this.customerId;
        };

        OptInOutView.prototype.getModel = function () {
            if (this.optInOutIndex != -1) {
                return OptInOutData.getByIndex(this.optInOutIndex);
            }
            return null;
        };

        OptInOutView.prototype.updateModel = function (success, failure, customerId) {
            if (customerId)
                this.customerId = customerId;
            var optInOut = this.getModel();
            if (optInOut == null) {
                optInOut = new OptInOut(null, customerId);
                this.optInOutIndex = OptInOutData.getIndexOf(optInOut);
                var customer = CustomerData.getById(customerId);
                if (customer) {
                    customer.optInOut = optInOut;
                }
            }

            this.copyDataTo(optInOut);

            OptInOutSrv.save(optInOut, success, failure);
        };

        OptInOutView.prototype.reloadModel = function () {
            var optInOut = this.getModel();

            this.loadDataFrom(optInOut);
        };

        OptInOutView.prototype.isAgreementKnown = function () {
            var isAgreementKnown = false;
            if (this.getModel()) {
                isAgreementKnown = true;
            }
            return isAgreementKnown;
        };

        OptInOutView.prototype.onDateOptInOutStringChange = function () {
            if (this.optInOutDateString && this.optInOutDateString.length == 10) {
                var year = this.optInOutDateString.substring(6, 10);
                var month = this.optInOutDateString.substring(3, 5);
                var day = this.optInOutDateString.substring(0, 2);
                this.timeModified = new Date(year + '/' + month + '/' + day);
                if (this.timeModified)
                    if (Object.prototype.toString.call(this.timeModified) === "[object Date]") {
                        if (isNaN(this.timeModified.getTime()))
                            this.timeModified = null;
                    } else {
                        this.timeModified = null;
                    }
            } else
                this.timeModified = null;
        }
        OptInOutView.prototype.onDateOptInOutStringKeyup = function (event)//
        {
            if (this.optInOutDateString)
                if (!(event && (event.which == 8 || event.which == 46))) //if key delete detected : clear supplier
                {
                    if ((this.optInOutDateString.length == 4 || this.optInOutDateString.length == 7) && (this.optInOutDateString[this.optInOutDateString.length - 1] == '/'))
                        this.optInOutDateString = this.optInOutDateString.substr(0, this.birthDateString.length - 2);

                    if (this.optInOutDateString.length == 2 || this.optInOutDateString.length == 5)
                        this.optInOutDateString += "/";
                }
        };

        OptInOutView.prototype.displayOptInOutDatePickerF = function () {
            var optInOutView = this;
            $timeout(function () {
                optInOutView.optInOutDatePickerOpened = true;
            })
        };

        OptInOutView.prototype.updateDateString = function () {
            if (this.timeModified)
                this.optInOutDateString = $filter('date')(this.timeModified, 'shortDate');
        }

        OptInOutView.prototype.canSaveExternalOptInOut = function () {
            if (this.timeModified == null || this.timeModified == '' || this.origin == null || this.origin == '')
                return false;
            return true;
        }

        return OptInOutView;
    }
]);



// WEBPACK FOOTER //
// ./js/services/views/OptInOutView.js